<template src="./MerchantDetails/MerchantPickup.html"></template>
<script>
import ImageGallery from '@/widgets/ImageGallery'
import estateTypeLabels from '@/utils/estate-type-labels'

export default {
    name: 'MerchantPickup',
    components: {
        ImageGallery,
    },
    props: {
        consignment: Object,
        pickupHistory: Object,
    },
    data: () => ({
        openImageGallery: false,
        imageGalleryTitle: '',
        imageGalleryImages: [],
    }),
    computed: {
        estateType() {
            return estateTypeLabels[this.$props.consignment.address.settings.estateType]
        },
        numberOfPalletsCollected() {
            const merchant = this.pickupHistory.merchants.find(
                (m) => m.name === this.consignment.merchantName,
            )
            return merchant.pallets !== null ? merchant.pallets : 0
        },
    },
    methods: {
        onGalleryClose() {
            this.openImageGallery = false
        },
        onPhotosOpen() {
            this.openImageGallery = true
            this.imageGalleryTitle = 'Photos'
            this.imageGalleryImages = this.consignment.images.map((image) => image.url)
        },
        onSignaturesOpen() {
            this.openImageGallery = true
            this.imageGalleryTitle = 'Signatures'
            this.imageGalleryImages = this.consignment.signatures.map((image) => image.url)
        },
    },
}
</script>
<style lang="scss" scoped>
.card {
    margin-bottom: 10px;
}

.task-dashboard {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 10px;
    border-left: solid 0px slategrey;
}

.dashboard-row {
    display: flex;
    width: 100%;
}

.dashboard-row-single {
    margin-right: 10px;
}

.dashboard-row-child {
    flex: 1;
    margin-right: 10px;
}

.special-instructions-content {
    padding: 10px;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
}
</style>
